import { selectPerpsProvider } from 'state/futures/common/selectors'
import { PerpsProvider } from 'state/futures/types'
import { useAppSelector, useFetchAction } from 'state/hooks'
import { selectWallet } from 'state/wallet/selectors'

import { fetchV2Leaderboard, fetchV3Leaderboard } from './actions'
import { selectValidSearchTerm } from './selectors'

export const useLeaderboardData = () => {
	const searchTerm = useAppSelector(selectValidSearchTerm)
	const wallet = useAppSelector(selectWallet)
	const perpsProvider = useAppSelector(selectPerpsProvider)

	useFetchAction(fetchV2Leaderboard, {
		dependencies: [searchTerm, wallet],
		disabled: perpsProvider !== PerpsProvider.SNX_V2,
	})

	useFetchAction(fetchV3Leaderboard, {
		dependencies: [searchTerm, wallet],
		disabled: perpsProvider !== PerpsProvider.SNX_V3,
	})
}
